// BroadcastHeader.js
import React from "react";
import { useNavigate } from "react-router-dom";

export default function BroadcastHeader({ broadcastName, onOpenMessageDrawer, setShowAI, broadcastId, playlistId }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-2xl font-bold">{broadcastName}</h1>
      <div className="flex gap-2">
        <button
          onClick={onOpenMessageDrawer}
          className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
        >
          Messages
        </button>
        <button
          onClick={() =>
            navigate(`/broadcasts/playlists/${playlistId}/broadcasts/${broadcastId}/ai`)
          }
          className="px-4 py-2 rounded bg-[#a56dff] text-white font-bold hover:bg-[#8f54d1] transition"
        >
          ✨ IA
        </button>
      </div>
    </div>
  );
}
